import moment from "moment";
import { ToastOptions } from "react-toastify";
import { DatesCalendarConfigType, DaysType, OptionsType } from "./Types";

export const maxBookingPeriodDays: number = 365;

export const maxDriverAge: number = 75;

export const minDriverAge: number = 25;

export const maxDriverAgeDate = moment().subtract(maxDriverAge, 'years').toDate();

export const minDriverAgeDate = moment().subtract(minDriverAge, 'years').toDate();

// In pence
export const depositAmount: number = 10000;

// In pence
export const minPaymountAmount: number = 500;

// Reviews Carousel
export const maxNoReviewsVisible = 3;

// My Bookings table
export const bookingsPerPage: number = 5;

// Booking calendar
export const calendarConfig: DatesCalendarConfigType = {
    getUnavailableDates: true,
    includeWeekends: true,
    lockBankHolidays: true,
    showDailyPrices: false,
    maxSearchableMnthsRng: 12
};

//// Lists for various select options
export const titleOptions: OptionsType[] = [
    { value: 'Mr', desc: 'Mr' },
    { value: 'Mrs', desc: 'Mrs' },
    { value: 'Miss', desc: 'Miss' },
    { value: 'Ms', desc: 'Ms' },
    { value: 'Sir', desc: 'Sir' },
    { value: 'Dr', desc: 'Dr' }
];

export const noAccidentsOptions: OptionsType[] = [
    { value: '0', desc: '0' },
    { value: '1', desc: '1' },
    { value: '2', desc: '2' },
    { value: '3', desc: '3' },
    { value: '4', desc: '4 or more' }
];

export const countryOptions: OptionsType[] = [
    { value: 'ENG', desc: 'England' },
    { value: 'SCO', desc: 'Scotland' },
    { value: 'WAL', desc: 'Wales' },
    { value: 'NIR', desc: 'Northern Ireland' },
    { value: 'IRL', desc: 'Eire' }
];

export const genderOptions: OptionsType[] = [
    { value: 0, desc: 'Male' },
    { value: 1, desc: 'Female' }
];

export const issueByOptions: OptionsType[] = [
    { value: 'UK', desc: 'UK' },
    { value: 'Other', desc: 'Other' }
];

export const daysList = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat", "Sun"];

export const handoverDays: DaysType[] = ["Mon", "Fri"];

export const toastConfig: ToastOptions = {
    position: "bottom-center",
    theme: "light",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
};

export const motorhomeImagePath: string = "/images/vehicles/";